import "@mantine/core/styles.css";
import "@mantine/carousel/styles.css";
import "./styles/global.css";

import React from "react";
import { type RouteRecord, ViteReactSSG } from "vite-react-ssg";

import Layout from "./layout";

export const routes: RouteRecord[] = [
  {
    path: "/",
    element: <Layout />,
    entry: "src/layout.tsx",
    children: [
      { index: true, Component: React.lazy(() => import("./pages/home")) },
      { path: "terms", Component: React.lazy(() => import("./pages/terms")) },
      { path: "privacy", Component: React.lazy(() => import("./pages/privacy")) },
    ],
  },
];

export const createRoot = ViteReactSSG({ routes });
